<template>
  <div class="course-statistics">
    <div class="course-statistics-body">
      <p class="breadcrumbs">
        <img
          src="@/assets/img/icon/icon4.png"
          alt=""
          @click="router.go(-1)"
          style="cursor: pointer"
        />
        {{ dataStatisticsInfo.courseName }}
      </p>
      <div class="info-box">
        <StatisticsData :info="dataStatisticsInfo" />
        <StatisticsResource ref="resourceRef" />
      </div>
      <div class="record">
        <div class="title">
          <img src="@/assets/img/icon/icon19.png" alt="" />学习记录
        </div>
        <div class="record-tree">
          <div class="tree-head">
            <div>学习单元体系</div>
            <div>学习状态</div>
            <div>详情</div>
          </div>
          <a-collapse
            v-model="activeKey"
            expandIconPosition="right"
            :bordered="false"
          >
            <!--            <template #expandIcon="{ isActive }">
              <img src="@/assets/img/icon/icon8.png" alt="" :class="{'active':isActive}"/>
            </template>-->
            <a-collapse-panel
              v-for="el in treeList"
              :key="el.id"
              :header="el.chapterName"
              class="section"
              :show-arrow="false"
            >
              <RecordOutline
                :info="el.children"
                :distributeWay="distributeWay"
              />
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsResource from "./components/statisticsResource.vue";
import StatisticsData from "./components/statisticsData.vue";
import {
  getStudyDataStatistics,
  getResourceCompleteStatistics,
  courseStudy,
  getCourseChapterTree,
} from "@/api/activity";
import RecordOutline from "./components/recordOutline.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    StatisticsResource,
    StatisticsData,
    RecordOutline,
  },
  data() {
    return {
      treeList: [],
      activeKey: [],
      courseStudyId: "",
      dataStatisticsInfo: {},
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    distributeWay: function () {
      return this.$route.query.distributeWay;
    },
    courseId: function () {
      return this.$route.query.courseId;
    },
  },
  mounted() {
    this.loadStudy();
    this.loadTree();
  },
  methods: {
    async loadStudy() {
      const res = await courseStudy({
        courseId: this.courseId,
        userId: this.userInfo.id,
      });
      this.courseStudyId = res.data.id;
      await this.studyDataStatistics();
      await this.resourceCompleteStatistics();
    },
    async studyDataStatistics() {
      await getStudyDataStatistics({ id: this.courseStudyId }).then((res) => {
        console.log(res);
        this.dataStatisticsInfo = res;
      });
    },
    async resourceCompleteStatistics() {
      await getResourceCompleteStatistics({ id: this.courseStudyId }).then(
        (res) => {
          console.log(res);
          this.$refs.resourceRef.load(res);
        }
      );
    },
    loadTree() {
      getCourseChapterTree({
        courseId: this.courseId,
        userId: this.userInfo.id,
      }).then((res) => {
        this.treeList = res;
        res.forEach((el) => {
          this.activeKey.push(el.id);
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.course-statistics {
  flex: 1;
  padding: 32px;
  background: #f9fafc;
  display: flex;
  flex-direction: column;
  .course-statistics-body {
    width: 1200px;
    margin: 0 auto;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
.breadcrumbs {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 400;
  color: #323233;
  line-height: 28px;
  margin-bottom: 32px;
  > img {
    margin-right: 8px;
  }
}

.info-box {
  display: flex;
  justify-content: space-between;
}

.record {
  padding: 24px;
  background: #ffffff;
  border-radius: 8px;
  margin-top: 24px;
  > .title {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
    line-height: 22px;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    > img {
      margin-right: 8px;
    }
  }
  > .record-tree {
    > .tree-head {
      display: flex;
      padding: 17px 0;
      background: #f6f7fb;
      border-radius: 4px 4px 0px 0px;
      font-size: 14px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 20px;
      > :first-child {
        width: 758px;
        padding: 0 24px;
      }
      > :nth-child(2) {
        width: 263px;
        padding-right: 24px;
      }
      > :nth-child(3) {
        width: 131px;
        padding-right: 24px;
      }
    }
    ::v-deep .ant-collapse {
      background-color: transparent;
      border: 0;
      > .ant-collapse-item {
        border: 0;
      }
      .ant-collapse-content-box {
        padding: 0;
      }
      .ant-collapse-content {
        border: 0;
      }
      .section {
        > .ant-collapse-header {
          background: #f6f7fb;
          border-radius: 0px 0px 4px 4px;
          font-size: 16px;
          font-weight: 600;
          color: #262626;
          line-height: 22px;
          padding: 17px 24px;
        }
      }
      .outline-class {
        > .ant-collapse-header {
          padding: 17px 24px;
          margin-bottom: 8px;
        }
      }
    }
  }
}
</style>
